import { render, staticRenderFns } from "./UserActivities.vue?vue&type=template&id=1f74c900&scoped=true&"
import script from "./UserActivities.vue?vue&type=script&lang=js&"
export * from "./UserActivities.vue?vue&type=script&lang=js&"
import style0 from "./UserActivities.vue?vue&type=style&index=0&id=1f74c900&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f74c900",
  null
  
)

export default component.exports